/**
 * Supabase `functions.invoke` errors often include a `context: Response` with a JSON body
 * that is more specific than `error.message`. Use this for user-facing and log messages.
 */
export async function messageFromFunctionsInvokeError(
  error: unknown,
): Promise<string> {
  if (error == null) return "Erreur réseau (Edge Function)";
  const e = error as { message?: string; context?: Response };
  let msg =
    typeof e.message === "string" && e.message.trim()
      ? e.message
      : "Erreur réseau (Edge Function)";
  const res = e.context;
  if (res && typeof res.clone === "function") {
    try {
      const j = (await res.clone().json()) as {
        error?: string;
        message?: string;
      };
      if (typeof j?.error === "string" && j.error.trim()) msg = j.error;
      else if (typeof j?.message === "string" && j.message.trim())
        msg = j.message;
    } catch {
      /* non-JSON body */
    }
  }
  return msg;
}
